import React, { useState } from 'react';
import { LegalPage } from '../components/legal/LegalPage';
import { termsAndConditions } from '../data/legal/termsAndConditions';
import { detectLang } from '../utils/lang';
export function TermsAndConditionsPage() {
  const [lang] = useState(detectLang);
  return <LegalPage doc={termsAndConditions[lang]} lang={lang} data-id="element-1207" data-mp="2aobvd2wzh61l" />;
}